import Toolbar from './Toolbar';
import classes from '../CMSMarkdownEditor.module.scss';

const Input = ({
	onChangeHandler,
	onCursorChange,
	value,
	inputRef,
	onClickHandler,
	disabled,
	id,
}) => {
	return (
		<div className={classes['input__container']}>
			<Toolbar onClickHandler={onClickHandler} />
			<textarea
				ref={inputRef}
				onKeyDown={e => onCursorChange(e.target.selectionStart)}
				onChange={e => onChangeHandler(e.target.value)}
				value={value}
				disabled={disabled}
				id={id}
			/>
		</div>
	);
};
export default Input;
